define.alias("shared/components/shared/ui/report/industry-comparison", "preview-grid/components/shared/ui/report/industry-comparison");